import { useContext } from 'react';
import { BrazeContext } from './BrazeContext';

export const useBraze = () => useContext(BrazeContext);
